import { type PresetSize } from './types';

export const presetSizes: { [K in PresetSize]: number } = {
	xsmall: 12,
	small: 16,
	medium: 24,
	large: 48,
	xlarge: 96,
};
